<div class="container-fluid p-0 m-0">
    <app-shared [type]="'retour-fournisseur'" [status]="'Retourné'"></app-shared>
</div>
